export const PACKAGE_VERSION = '1.1.1'
